// @flow
import React from 'react';

import { constants } from '@clubmed/utils';

import Grid from 'Components/frameworks/grid/Grid.jsx';
import { Product } from 'Components/widgets/product/Product.jsx';
import { getProductBadgeIcon, isExclusiveCollection } from 'Components/utils/product/product.utils';
import { getTagsAndBadgeColor, getLogo } from 'Components/widgets/product/Product.mapper';

import { type SearchSuggestionsBlockProps } from './GlobalSearchSuggestionsList.jsx';

const { PRODUCT_TYPES, PRODUCT_ICON } = constants;

export const MAX_GRID_SUGGESTIONS = 4;

export const GlobalSearchSuggestionsGrid = (props: SearchSuggestionsBlockProps) => {
  const products = props.blockSuggestions
    .slice(0, MAX_GRID_SUGGESTIONS)
    .map(
      ({
        comfortLevel,
        icon,
        image,
        label,
        link,
        productId,
        productType,
        season,
        subLabel1,
        subLabel2,
      }) => {
        const comfort = parseInt(comfortLevel, 10);
        let badgeIcon;
        switch (productType) {
          case PRODUCT_TYPES.TOUR:
            badgeIcon = PRODUCT_ICON.TOUR;
            break;
          case PRODUCT_TYPES.CRUISE:
            badgeIcon = PRODUCT_ICON.CRUISE;
            break;
          case PRODUCT_TYPES.JOYVIEW:
            badgeIcon = PRODUCT_ICON.RESORT_JOYVIEW;
            break;
          default:
            badgeIcon = icon.toUpperCase();
            break;
        }
        return {
          id: productId,
          type: productType,
          header: {
            dataProductId: productId,
            dataProductType: productType,
            heading: {
              title: label,
              subtitle: productType === PRODUCT_TYPES.RESORT ? subLabel1 : subLabel2,
            },
            badge: season,
            badgeColor: getTagsAndBadgeColor({ type: productType }),
            badgeIcon: getProductBadgeIcon({
              comfort,
              badgeIcon,
              type: productType,
            }),
            logo: getLogo({ type: productType }),
          },
          thumbnail: {
            badgeColor: getTagsAndBadgeColor({ type: productType }),
            hasBorder: isExclusiveCollection(productType, comfort),
            pictures: [
              {
                altMsg: label,
                src: image,
              },
            ],
          },
          url: link,
        };
      },
    );
  const grid = {
    desktop: 2,
    mobile: 1,
    phablet: 2,
    tablet: 3,
  };
  return (
    products.length > 0 && (
      <Grid
        className="mb-6"
        display={grid}
        grid={grid}
        hasSeeMore={false}
        totalNumberToDisplay={MAX_GRID_SUGGESTIONS}
      >
        {products.map(product => (
          <Product
            key={product.id}
            {...product}
            onClick={() => {
              const query = { label: product.header.heading.title, type: 'resort' };
              props.onClick(query);
            }}
          />
        ))}
      </Grid>
    )
  );
};
